import { render, staticRenderFns } from "./asides2.vue?vue&type=template&id=a092a466&scoped=true&"
import script from "./asides2.vue?vue&type=script&lang=js&"
export * from "./asides2.vue?vue&type=script&lang=js&"
import style0 from "./asides2.vue?vue&type=style&index=0&id=a092a466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a092a466",
  null
  
)

export default component.exports